import { FC } from "react";
import { Heading } from "@/components/Html/Heading";
import { Section } from "@/components/Html/Section";
import { PostItem, RelatedPost } from "./PostItem/PostItem";

interface Props {
  posts: RelatedPost[];
}

export const RightSideRelatedPosts: FC<Props> = ({ posts }) => {
  return (
    <Section className="flex flex-col pt-[16px] md:pt-[24px]">
      <Heading heading="2" className="mb-[16px] border-b text-[24px]">
        関連記事
      </Heading>
      <div className="flex flex-col gap-[16px] md:gap-[24px]">
        {posts.map((post) => (
          <PostItem key={post.sys.id} post={post} />
        ))}
      </div>
    </Section>
  );
};
